function toValidDate(value: string): Date | null {
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

export function extractYearMonth(dateString: string) {
  const date = toValidDate(dateString);
  if (!date) return { year: NaN, month: NaN };
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
  };
}

export function getAvailableYears(dates: string[]) {
  const years = dates
    .map(toValidDate)
    .filter((d): d is Date => !!d)
    .map((d) => d.getUTCFullYear());
  return [...new Set(years)].sort((a, b) => b - a);
}

export function getAvailableMonths(dates: string[], year: number) {
  const months = dates
    .map(toValidDate)
    .filter((d): d is Date => !!d && d.getUTCFullYear() === year)
    .map((d) => d.getUTCMonth() + 1);
  return [...new Set(months)].sort((a, b) => a - b);
}

export function formatMonth(month: number) {
  return new Date(2000, month - 1, 1).toLocaleDateString("no-NO", {
    month: "long",
  });
}
